import React from "react"
import WishListContext from "contexts/WishList"
import useWishListContextData from "contexts/WishList/useWishListContextData"
import { FeatureFlagReadModel } from "featureFlags"

interface ProviderProps {
  children: React.ReactNode
  featureFlagReadModel?: FeatureFlagReadModel
}

const WishListProvider = ({
  children,
  featureFlagReadModel
}: ProviderProps) => {
  const data = useWishListContextData({ featureFlagReadModel })

  return (
    <WishListContext.Provider value={data}>{children}</WishListContext.Provider>
  )
}

export default WishListProvider
